import { render } from "./Messaging.vue?vue&type=template&id=add82cce"
const script = {}

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__